var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeApply active edit" },
    [
      _c(
        "van-cell-group",
        {},
        [
          _c(
            "van-cell",
            {
              attrs: { title: "活动名称" },
              on: {
                click: function($event) {
                  _vm.showAllActive = !_vm.showAllActive
                }
              }
            },
            [
              _vm.report.campName
                ? _c("p", { staticClass: "item2 date-time black" }, [
                    _vm._v(_vm._s(_vm.report.campName))
                  ])
                : _c("p", { staticClass: "item2 date-time" }, [
                    _vm._v("请选择活动名称")
                  ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "triangle_border_down",
                attrs: { slot: "right-icon" },
                slot: "right-icon"
              })
            ]
          ),
          _vm._v(" "),
          _vm.report.U_RangeTime
            ? _c("van-cell", { attrs: { title: "活动日期" } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "flex item1" }, [
                      _vm.report.U_RangeTime
                        ? _c("p", { staticClass: "item1 date-time black" }, [
                            _vm._v(_vm._s(_vm.firstDate))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v("\n        至\n        "),
                    _c(
                      "van-popup",
                      {
                        attrs: { position: "bottom" },
                        model: {
                          value: _vm.showDateTime1,
                          callback: function($$v) {
                            _vm.showDateTime1 = $$v
                          },
                          expression: "showDateTime1"
                        }
                      },
                      [
                        _c("van-datetime-picker", {
                          attrs: { type: "date", "min-date": new Date() },
                          on: {
                            confirm: _vm.getFirstDate,
                            cancel: function($event) {
                              _vm.showDateTime1 = !_vm.showDateTime1
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex item1" }, [
                      _vm.report.U_RangeTime
                        ? _c("p", { staticClass: "item1 date-time black" }, [
                            _vm._v(_vm._s(_vm.endDate))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "van-popup",
                      {
                        attrs: { position: "bottom" },
                        model: {
                          value: _vm.showDateTime2,
                          callback: function($$v) {
                            _vm.showDateTime2 = $$v
                          },
                          expression: "showDateTime2"
                        }
                      },
                      [
                        _c("van-datetime-picker", {
                          attrs: { type: "date", "min-date": new Date() },
                          on: {
                            confirm: _vm.getLastDate,
                            cancel: function($event) {
                              _vm.showDateTime2 = !_vm.showDateTime2
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.report.U_CampPlace
            ? _c("van-cell", { attrs: { title: "活动地点" } }, [
                _c("p", { staticClass: "item2 date-time black" }, [
                  _vm._v(_vm._s(_vm.report.U_CampPlace))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.report.U_InvitedCnt
            ? _c("van-cell", { attrs: { title: "预计人数" } }, [
                _c("p", { staticClass: "item2 date-time black" }, [
                  _vm._v(
                    _vm._s(_vm.$numeral(_vm.report.U_InvitedCnt).format("0,0"))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "到场人数" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入到场人数", type: "number" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "report", "U_OnSiteCnt")
                  }
                },
                model: {
                  value: _vm.report.U_OnSiteCnt,
                  callback: function($$v) {
                    _vm.$set(_vm.report, "U_OnSiteCnt", $$v)
                  },
                  expression: "report.U_OnSiteCnt"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "集客目标" } }, [
            _c("p", { staticClass: "item2 date-time black" }, [
              _vm._v(
                _vm._s(_vm.$numeral(_vm.report.U_FansTarget).format("0,0"))
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "集客人数" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入集客人数", type: "number" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "report", "U_CollectionCnt")
                  }
                },
                model: {
                  value: _vm.report.U_CollectionCnt,
                  callback: function($$v) {
                    _vm.$set(_vm.report, "U_CollectionCnt", $$v)
                  },
                  expression: "report.U_CollectionCnt"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "销售目标" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入销售目标" },
                model: {
                  value: _vm.report.U_SalesTarget,
                  callback: function($$v) {
                    _vm.$set(_vm.report, "U_SalesTarget", $$v)
                  },
                  expression: "report.U_SalesTarget"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "调查问卷" } },
            [
              _c(
                "van-radio-group",
                {
                  staticClass: "flex ",
                  model: {
                    value: _vm.report.U_Survey,
                    callback: function($$v) {
                      _vm.$set(_vm.report, "U_Survey", $$v)
                    },
                    expression: "report.U_Survey"
                  }
                },
                [
                  _c(
                    "van-radio",
                    {
                      staticClass: "radio",
                      attrs: { name: "1" },
                      scopedSlots: _vm._u([
                        {
                          key: "icon",
                          fn: function(props) {
                            return _c("img", {
                              staticClass: "radioImg",
                              attrs: {
                                src: props.checked ? _vm.Icon[0] : _vm.Icon[1]
                              }
                            })
                          }
                        }
                      ])
                    },
                    [_vm._v(" 有\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-radio",
                    {
                      staticClass: "radio",
                      attrs: { name: "0" },
                      scopedSlots: _vm._u([
                        {
                          key: "icon",
                          fn: function(props) {
                            return _c("img", {
                              staticClass: "radioImg",
                              attrs: {
                                src: props.checked ? _vm.Icon[0] : _vm.Icon[1]
                              }
                            })
                          }
                        }
                      ])
                    },
                    [_vm._v(" 无\n          ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "完成人数" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入完成人数" },
                model: {
                  value: _vm.report.U_SurveyCnt,
                  callback: function($$v) {
                    _vm.$set(_vm.report, "U_SurveyCnt", $$v)
                  },
                  expression: "report.U_SurveyCnt"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("实际费用")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-text" }, [
                  _vm._v(
                    "（未税" +
                      _vm._s(
                        _vm
                          .$numeral(_vm.totalBudget.amount || 0)
                          .format("0,0.00")
                      ) +
                      "，含税" +
                      _vm._s(
                        _vm
                          .$numeral(_vm.totalBudget.unamount || 0)
                          .format("0,0.00")
                      ) +
                      "）"
                  )
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table van-hairline--surround" },
            [
              _c("div", { staticClass: "table-title flex " }, [
                _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                _vm._v(" "),
                _c("p", { staticClass: "item2" }, [_vm._v("名称")]),
                _vm._v(" "),
                _c("p", { staticClass: "item1" }, [_vm._v("数量")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("未税费用")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("含税费用")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.costList, function(item, index) {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "table-content flex van-hairline--top",
                      on: {
                        click: function($event) {
                          return _vm.yusuanEdit(item, index)
                        }
                      }
                    },
                    [
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(index + 1))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(item.Name))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(_vm.$numeral(item.U_Qty).format("0,0")))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item3 van-hairline--right" }, [
                        _vm._v(
                          _vm._s(_vm.$numeral(item.U_Amount).format("0,0.00"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "item3 flex" },
                        [
                          _c(
                            "p",
                            { staticClass: "item1 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$numeral(item.U_AmountAftTax)
                                    .format("0,0.00")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("van-icon", {
                            staticClass: "close",
                            attrs: { name: "cross" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.costList.splice(index, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-content add-table van-hairline--top",
                  on: {
                    click: function($event) {
                      return _vm.yusuanEdit()
                    }
                  }
                },
                [_vm._v("\n        +添加一栏\n      ")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "clear" },
            [
              _vm._l(_vm.costImgList, function(img, index) {
                return _c(
                  "p",
                  { staticClass: "upload-img fl" },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.$config.serverURL + "upload/" + img.U_url,
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("van-icon", {
                      staticClass: "del-icon",
                      attrs: { name: "clear", color: "#e83c39", size: "20px" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.costImgList.splice(index, 1)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "van-uploader",
                {
                  staticClass: "upload ",
                  attrs: { "after-read": _vm.afterRead, multiple: "" }
                },
                [
                  _c("van-icon", { attrs: { name: "plus" } }),
                  _vm._v(" "),
                  _c("p", [_vm._v("上传发票")])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("当天销售情况")
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table van-hairline--surround" },
            [
              _c("div", { staticClass: "table-title flex " }, [
                _c("p", { staticClass: "item2" }, [_vm._v("序号")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("产品一级分类")]),
                _vm._v(" "),
                _c("p", { staticClass: "item2" }, [_vm._v("产品名称")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("金额")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.saleList, function(item, index) {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "table-content flex van-hairline--top",
                      on: {
                        click: function($event) {
                          return _vm.saleEdit(item, index)
                        }
                      }
                    },
                    [
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(index + 1))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item3 van-hairline--right" }, [
                        _vm._v(
                          _vm._s(item.U_ProductClass1 || item.productClass1Name)
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(item.U_ProductName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "item3 flex last" },
                        [
                          _c(
                            "p",
                            { staticClass: "item1 van-hairline--right" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$numeral(item.U_Amount).format("0,0.00")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("van-icon", {
                            staticClass: "close",
                            attrs: { name: "cross" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.saleList.splice(index, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-content add-table van-hairline--top",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.saleEdit()
                    }
                  }
                },
                [_vm._v("\n        +添加一栏\n      ")]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "活动总结" } }),
          _vm._v(" "),
          _c("quillEditImg", {
            attrs: { quillId: "U_Summary", content: _vm.report.U_Summary },
            on: {
              change: function($event) {
                return _vm.onEditorChange($event, "U_Summary")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "现场照片" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "clear" },
            [
              _vm._l(_vm.reportImgList, function(img, index) {
                return _c(
                  "p",
                  { staticClass: "upload-img fl" },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.$config.serverURL + "upload/" + img.U_url,
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("van-icon", {
                      staticClass: "del-icon",
                      attrs: { name: "clear", color: "#e83c39", size: "20px" },
                      on: {
                        click: function($event) {
                          return _vm.reportImgList.splice(index, 1)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "van-uploader",
                {
                  staticClass: "upload ",
                  attrs: { "after-read": _vm.afterRead2, multiple: "" }
                },
                [
                  _c("van-icon", { attrs: { name: "plus" } }),
                  _vm._v(" "),
                  _c("p", [_vm._v("上传图片")])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-btn flex" }, [
        _c(
          "div",
          {
            staticClass: "item1 btn save",
            on: {
              click: function($event) {
                return _vm.sub(_vm.campStatus.D)
              }
            }
          },
          [_vm._v("保存")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item1 btn sub",
            on: {
              click: function($event) {
                return _vm.sub(_vm.campStatus.W)
              }
            }
          },
          [_vm._v("提交")]
        )
      ]),
      _vm._v(" "),
      _c("dateTime", {
        on: { endChange: _vm.dateChange },
        model: {
          value: _vm.showDateTime,
          callback: function($$v) {
            _vm.showDateTime = $$v
          },
          expression: "showDateTime"
        }
      }),
      _vm._v(" "),
      _c("yusuanPop", {
        attrs: { info: _vm.yusuanValue },
        on: { newYusuan: _vm.newYusuan },
        model: {
          value: _vm.showYusuan,
          callback: function($$v) {
            _vm.showYusuan = $$v
          },
          expression: "showYusuan"
        }
      }),
      _vm._v(" "),
      _c("salesPop", {
        attrs: { info: _vm.saleValue },
        on: { newSales: _vm.newSales },
        model: {
          value: _vm.showSales,
          callback: function($$v) {
            _vm.showSales = $$v
          },
          expression: "showSales"
        }
      }),
      _vm._v(" "),
      _c("salesPop2", {
        on: { newSales: _vm.newSalesmonth },
        model: {
          value: _vm.showSalesmonth,
          callback: function($$v) {
            _vm.showSalesmonth = $$v
          },
          expression: "showSalesmonth"
        }
      }),
      _vm._v(" "),
      _c("allActive", {
        on: { getAllActive: _vm.getAllActive },
        model: {
          value: _vm.showAllActive,
          callback: function($$v) {
            _vm.showAllActive = $$v
          },
          expression: "showAllActive"
        }
      }),
      _vm._v(" "),
      _c("backTo", { attrs: { url: "/active/reportList" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34ab72be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34ab72be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/reportApply.vue
// module id = null
// module chunks = 